<template>
  <cw-main class="receiptMain">
    <a-row type="flex">
      <!-- 第一部分 -->
      <a-col :lg="15">
        <div class="steps">
          <a-steps :current="2">
            <a-step :title="$t('shopping-cart-title')" />
            <a-step :title="$t('transaction-preview')" />
            <a-step :title="$t('receipt-title')" />
          </a-steps>
        </div>

        <div class="tips" v-show="Object.keys(orderInfo).length > 0">
          <template v-if="true">
            <div class="tips-title">
              <a-icon type="check" />
              <span>{{ $t('thank-you-title') }}</span>
            </div>
            <div class="tips-content">
              <span>{{ $t('complete-ack-1') }}</span>
              <span>{{ $t('complete-ack-2') }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tips-title">
              <span style="color: red">{{ $t('PAYMENT_FAIL') }}</span>
            </div>
          </template>
        </div>

        <div class="mobileBlock" v-if="orderInfo">
          <h4 class="title">{{ $t('ticket-detail-title') }}</h4>
          <ticket-card
            v-for="item in orderList"
            :key="item.orderId"
            :ticket="item"
            :seats="item.seats.seats"
            imageUrlKey="eventImageUrl"
            showPrice
            :preview="false"
          />
        </div>
        <h4 class="mobileBlock title" v-if="orderInfo">
          {{ $t('payment-details-title') }}
        </h4>
        <div class="table-box" v-show="Object.keys(orderInfo).length > 0">
          <table class="table-left">
            <tbody>
              <tr>
                <th>
                  <span> {{ $t('payment-type-title') }}: </span>
                </th>
                <td>
                  <span>{{ getName(paymentInfo, 'payType') }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span> {{ $t('card-no-title') }}: </span>
                </th>
                <td>
                  <span>{{ paymentInfo.cardNo }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span> {{ $t('delivery-method-title') }}: </span>
                </th>
                <td>
                  <span>{{ getName(orderInfo, 'deliveryName') }}</span>
                </td>
              </tr>

              <tr>
                <th>
                  <span> {{ $t('claim-id-title') }}: </span>
                </th>
                <td>
                  <span>{{ $t('refer-confirmation-email') }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span> {{ $t('claim-password-title') }}: </span>
                </th>
                <td>
                  <span>{{ $t('refer-confirmation-email') }}</span>
                </td>
              </tr>

              <tr>
                <th>
                  <span> {{ $t('email-address-title') }}: </span>
                </th>
                <td>
                  <span>{{ orderInfo.emailAddress }}</span>
                </td>
              </tr>
              <tr>
                <th>
                  <span> {{ $t('name-title') }}: </span>
                </th>
                <td>
                  <span> {{ orderInfo.name }} </span>
                </td>
              </tr>
              <tr>
                <th>
                  <span> {{ $t('contact-phone-no-title') }}: </span>
                </th>
                <td>
                  <span>{{
                    `${orderInfo.countryCode}-${orderInfo.phoneNumber}`
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-right">
            <table>
              <tbody>
                <tr>
                  <th>
                    <span> {{ $t('no-of-tickets-title') }}: </span>
                  </th>
                  <td>
                    <span>{{ getTotalQty }}</span>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span> {{ $t('ticket-total-price-title') }}: </span>
                  </th>
                  <td>
                    <span
                      >HK${{
                        $amountRule(
                          NP.minus(
                            Number(orderInfo.grandTotal),
                            Number(orderInfo.serviceCharge)
                          )
                        )
                      }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <span> {{ $t('handling-fee-title') }}: </span>
                  </th>
                  <td>
                    <span
                      >HK${{ $amountRule(orderInfo.serviceCharge || 0) }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <span> {{ $t('grand-total-title') }}: </span>
                  </th>
                  <td>
                    <span>HK${{ $amountRule(orderInfo.grandTotal) }}</span>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span> {{ $t('txn-number-title') }}: </span>
                  </th>
                  <td>
                    <span>{{ orderInfo.confirmationNumber }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <a-row
          class="mt-4 btn-wrap pcBlock"
          data-display="flex"
          type="flex"
          justify="end"
        >
          <a-col class="mt-1" :lg="{ span: 6, offset: 1 }">
            <a-button class="backHomeBtn" size="large" @click="goToHomePage">
              {{ $t('back-home-title') }}
            </a-button>
          </a-col>
          <!-- <a-col class="mt-1" :lg="{ span: 6, offset: 1 }">
            <a-button class="theme-btn" size="large" @click="printPDF">
              {{ $t('print-title') }}
            </a-button>
          </a-col> -->
        </a-row>
      </a-col>
      <!-- 第二部分 -->
      <a-col
        :lg="{ span: 8, offset: 1 }"
        class="shopping-right pcBlock"
        v-if="orderList"
      >
        <h4 class="performance-title">{{ $t('performance-title') }}</h4>
        <div class="ticket" v-for="item in orderList" :key="item.orderId">
          <ticket-card
            :ticket="item"
            :seats="item.seats.seats"
            imageUrlKey="eventImageUrl"
            showPrice
            :preview="false"
          />
          <div class="orderRemark">
            <div v-for="(remarkItem, idx) in item.remarks" :key="idx">
              <p class="remarkTitle">{{ getName(remarkItem, 'subject') }}</p>
              <p class="remarkInfo" v-html="getName(remarkItem, 'content')"></p>
            </div>
          </div>
          <hr />
        </div>
      </a-col>
    </a-row>
    <div class="fixedBtnWrap mobileBlock" data-display="flex">
      <a-button class="backHomeBtn" size="large" @click="goToHomePage">
        {{ $t('back-home-title') }}
      </a-button>
    </div>
  </cw-main>
</template>

<script>
import cwMain from '@/components/container/cw-main'
import ticketCard from '@/components/ticketCard.vue'
import { mapMutations } from 'vuex'
import { getOrderStatusApi } from '@/api/utsv.js'
import { getUtsvField } from '@/utils/utils'
import NP from 'number-precision'
export default {
  components: {
    cwMain,
    ticketCard
  },
  data () {
    return {
      orderInfo: {},
      paymentInfo: {},
      orderList: [],
      checked: false,
      maskedCreditCardNumber: '',
      NP
    }
  },
  created () {
    this.getOrderStatus()
  },
  computed: {
    getName () {
      return (obj, name) => {
        return obj ? getUtsvField(obj, name, this.$i18n.locale) : ''
      }
    },
    getTotalQty () {
      console.log(this.orderList)
      return this.orderList.reduce((total, cur) => {
        return total + cur.seats.seats.length
      }, 0)
    }
  },
  methods: {
    ...mapMutations(['setHandLoading', 'setGlobalLoading']),
    async getOrderStatus () {
      this.toggleLoading(true)
      const orderStatusRes = await getOrderStatusApi()
      if (!orderStatusRes) {
        window.location.href = '/'
        return
      }
      console.log('order status:', orderStatusRes)
      this.toggleLoading(false)
      if (orderStatusRes.status !== 'REQUEST_APPROVED') {
        this.$router.push({
          name: 'ShoppingBasket'
        })
        return
      }
      this.orderInfo = orderStatusRes.completeResult.receipt.orders
      this.orderList = this.orderInfo.orders.orders
      this.paymentInfo = orderStatusRes.payment
    },
    toggleLoading (bool = true) {
      if (bool) {
        this.setHandLoading(true)
        this.setGlobalLoading(true)
      } else {
        this.setHandLoading(false)
        this.setGlobalLoading(false)
      }
    },
    handleChange (e) {
      this.checked = e.target.checked
    },
    goToHomePage () {
      window.location.href = '/'
    },
    printPDF () {

    }
  }
}
</script>

<style lang="scss" scoped>
.receiptMain {
  @media (max-width: 991px) {
    margin: 0;
    @include background_color('white-background');
    padding: 5px 16px 100px;
  }
}
::v-deep svg {
  vertical-align: baseline;
}
::v-deep .ant-steps-item-process .ant-steps-item-icon {
  background-color: $theme-color-dark;
  border-color: $theme-color-dark;
  font-weight: 700;
  font-size: 1.125rem;
  color: #fff;
}

::v-deep .ant-steps-item-wait .ant-steps-item-icon {
  background-color: #cdd2fd;
  border-color: #cdd2fd;
  font-weight: 400;
  > .ant-steps-icon {
    color: #fff;
  }
}

::v-deep .steps {
  width: 80%;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: 100%;
  }
  .ant-steps {
    display: flex !important;
  }
  .ant-steps-item {
    flex: 1;
    margin: 0 !important;
    padding: 0 !important;
    .ant-steps-item-container {
      position: relative;
      margin-bottom: 40px;
      text-align: center;
      &::before {
        content: '';
        position: absolute;
        width: 50%;
        height: 0;
        top: 15px;
        left: 0;
        right: 0;
        border-bottom: 1px dashed #cdd2fd;
        z-index: 1;
      }
      &::after {
        content: '';
        position: absolute;
        width: 50%;
        height: 0;
        top: 15px;
        left: 50%;
        right: 0;
        border-bottom: 1px dashed #cdd2fd;
        z-index: 1;
      }
    }
    &:first-of-type .ant-steps-item-container::before {
      display: none;
    }
    &:last-of-type .ant-steps-item-container::after {
      display: none;
    }

    .ant-steps-item-tail {
      display: none !important;
    }
    .ant-steps-item-icon {
      float: none;
      margin: 0 !important;
      padding: 0 !important;
      position: relative;
      z-index: 2;
    }
    .ant-steps-item-content {
      position: absolute;
      top: calc(100% + 5px);
      left: 50%;
      transform: translateX(-50%);
    }
    .ant-steps-item-title {
      margin: 0 !important;
      font-size: 1rem;
      @media (max-width: 991px) {
        font-size: 0.75rem;
      }

      &::after {
        display: none;
      }
    }
  }
}

.tips {
  .tips-title {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    @include font_color('black27-font_color');
    @media (max-width: 991px) {
      flex-direction: column;
    }
    > i {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 3.5rem;
      height: 3.5rem;
      font-size: 2.5rem;
      color: #fff;
      background-color: #00c48c;
      border-radius: 50%;
    }
  }
}

.table-box {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  table {
    border-collapse: collapse;
    width: 100%;
    tr {
      height: 2.5rem;
    }
    th,
    td {
      vertical-align: top;
      font-size: 1rem;
    }
    th {
      white-space: nowrap;
      font-weight: bold;
      @include font_color('black15-font_color');
    }
    td {
      overflow-wrap: break-word;
      word-break: break-word;
      padding-left: 1rem;
      @include font_color('black27-font_color');
      font-weight: 400;
    }
  }
  .table-right {
    width: 100%;
    margin-left: 20px;
    td {
      text-align: right;
    }
  }
  @media (max-width: 81.25rem) {
    flex-direction: column;
    .table-right {
      margin-left: 0;
      padding-top: 20px;
      border-top: 1px solid rgba(228, 228, 228, 0.6);
    }
  }
  @media (max-width: 991px) {
    flex-direction: column;
    .table-right {
      margin-left: 0;
      padding-top: 20px;
      border-top: 1px solid rgba(228, 228, 228, 0.6);
    }
  }
}

.backHomeBtn {
  border-color: $theme-color-dark;
  background: transparent;
  color: $theme-color-dark;
}

.tnc-checkbox {
  font-size: 1rem;
  color: #212529;
  margin-right: 5px;
  ::v-deep .ant-checkbox-inner {
    border-color: $theme-color;
  }
}

.btn-wrap {
  .ant-btn {
    width: 100%;
  }
}

.shopping-right {
  @include background_color('shopping-right-bgc');
  .performance-title {
    margin-top: 10px;
    margin-bottom: 5px;
    padding: 15px;
    color: $theme-color;
    font-weight: 700;
    font-size: 1.3125rem;
  }

  .ticket {
    padding: 0 15px;
    overflow: auto;
    overflow-x: hidden;
    max-height: 59.0625rem;
    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 15px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 15px;
      @include background_color('scrollbar-bgc');
    }
    .ticket-item {
      padding-bottom: 40px;
      margin-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .ticketCard {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
    .ticket-body {
      padding: 0 15px;
      .ticket-desc-title {
        margin: 20px 0 0;
        font-size: 1rem;
        color: font_color('black27-font_color');
      }
    }

    .orderRemark {
      margin: 15px 0;
      @media (max-width: 991px) {
        padding: 15px;
      }
      .remarkTitle {
        margin: 0;
        @include font_color('detail-title');
      }
      .remarkInfo {
        margin: 0;
        @include font_color('performance-tip');
      }
    }
  }
}

h4.title {
  font-size: 0.875rem;
  color: $theme-color;
  font-weight: bold;
  margin: 16px 0 8px;
}

.mobileTicketCard {
  padding-bottom: 40px;
}

.fixedBtnWrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: 0;
  padding: 15px;
  @include background_color('white-background');
  box-shadow: 0px -4px 4px rgba(228, 228, 228, 0.6);
  z-index: 900;
  .ant-btn {
    flex: 1 1 50%;
    & + .ant-btn {
      margin-left: 15px;
    }
  }
}

[data-theme='black'] .fixedBtnWrap {
  box-shadow: 0px -4px 4px rgba(27, 27, 27, 0.4);
}
</style>
